window.sq = window.sq || {};
window.sq.config = window.sq.config || {};

function toggleFilter() {
  let x = document.querySelector(".sq-filter-main");
  x.classList.toggle("opening");
}
function toggleClass() {
  let y = document.querySelector(".sq-filter-main");
  y.classList.remove("opening");
}
function removeClass() {
  let z = document.querySelector(".sq-filter-main");
  z.classList.remove("opening");
}

function showHide() {

  document.querySelector(".sq-sort-title").classList.toggle("closed");
  var div = document.querySelectorAll(".sq-dropdown-wrapper")[0];
  if (div.style.display === "none") {
    div.style.display = "block";
  } else {
    div.style.display = "none";
  }
}

function sortOnClickValue() {
  // Get all the option labels
  const optionLabels = document.querySelectorAll(".value-picker__choice-item");

  // Add a click event listener to each label
  optionLabels.forEach((label) => {
    label.addEventListener("click", () => {
      // Remove the "selected" class from all the labels
      optionLabels.forEach((label) => {
        label.classList.remove("selected");
      });

      // Add the "selected" class to the clicked label
      label.classList.add("selected");
    });
  });
}

window.onload = function () {
  sortOnClickValue();
};